import 'angular:locale/data:en-GB';(globalThis.$localize ??= {}).locale = "en-GB";
